import React, { ReactNode } from 'react';
import { Bowtie } from './bowtie';
import { BowtieDisplayMode } from './external-types';

import styles from './bowtie-search-result.scss';
import { useInstanceKey } from 'app/area/favourite/favourite-context';

export const BowtieSearchResult: React.FC<React.PropsWithChildren<{ caseNumber: number; footer?: ReactNode; 
    height?: number; }>> =
  ({ caseNumber, footer, height }) => {
    const instanceKey = useInstanceKey();
    return <div className={styles.searchResult} style={{ height: height || 600 }}>
      <Bowtie
        key={caseNumber}
        caseNumber={caseNumber}
        displayMode={BowtieDisplayMode.searchResult}
        footer={footer} 
        instanceKey={instanceKey}
        />
    </div>;
  };
